import { render, staticRenderFns } from "./SeoBlock.vue?vue&type=template&id=0e98ed68"
import script from "./SeoBlock.vue?vue&type=script&lang=js"
export * from "./SeoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports